import request from "@/utils/request";

// 文件上传
export function fileUploadApi(data) {
  return request({
    url: "/file/upload",
    method: "post",
    data,
  });
}

// 文件预览
export function previewFileApi(data) {
  return request({
    url: "/file/preview",
    method: "post",
    data,
  });
}

// 获取字典数据
export function queryDictData(type) {
  return request({
    url: `/dict/type?type=${type}`,
    method: "get",
  });
}

// 获取组织架构树
export function queryOrgTree(data) {
  return request({
    url: "/org/getOrgTee",
    method: "post",
    data,
  });
}
